












































































































import {Component, Watch} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import DebounceMixin from '@/mixins/DebounceMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import {swalError} from '@/plugins/swal';

@Component
export default class Dashboard extends mixins(
  LoadingMixin,
  SnackbarMixin,
  DebounceMixin,
) {
  locationItems = [];
  jobsItems = [];
  list_education_level = ['SMP/SMK', 'Diploma', 'Sarjana', 'Magister'];
  category = [];
  location = null;
  jobtype = null;
  isLoading = false;
  page = 1;
  meta = [];
  items = [
    {
      src:
        'https://www.dictio.id/uploads/db3342/original/3X/6/b/6b3194ebea481506686ea44c0c76d00b89542529.jpeg',
    },
  ];
  categoryItems = [];
  currentPage = 1;
  maxPerPage = 3;
  showReadMore = true;
  orders = 10;
  search = null;
  education = null;
  @Watch('page')
  onPageChanged() {
    this.facthData();
  }
  doSearch() {
    this.page = 1;
    this.facthData();
  }
  async mounted() {
    await this.facthData();
    this.fecthCategory();
  }
  async facthData() {
    try {
      this.startLoading('detail');
      const params: any = {};
      params.page_size = 10;
      params.page = this.page;
      params.search = this.search ? this.search : null;
      params.category =
        this.category.length > 0 ? JSON.stringify(this.category) : null;
      // params.education = this.education;
      const {data, pagination} = await this.$store.dispatch('jobs/all', params);
      this.finishLoading('detail');
      this.jobsItems = data;
      this.page = pagination.page;
      this.meta = pagination;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$router.push('/');
      swalError.fire({
        title: 'Warning!',
        text: 'mohon lengkapi data, sebelum memulai pendaftaran',
      });
    }
  }
  async fecthCategory() {
    try {
      this.startLoading('detail');
      const params: any = {};
      const {data} = await this.$store.dispatch('jobs/category', params);
      this.finishLoading('detail');

      this.categoryItems = data;
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
}
